/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It uses the standard International Morse set — the letters A to Z, digits 0 to 9, and common punctuation. Accented letters and non-Latin scripts are not part of that table, so they are skipped when encoding.`)
};

const es_mc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliza el conjunto estándar International Morse — las letras A to Z, dígitos 0 to 9, y puntuación común. Las letras acentuadas y los scripts no latinos no forman parte de esa tabla, por lo que se omiten al codificar.`)
};

const de_mc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wird der Standard-Zeichensatz des International Morse verwendet — die Buchstaben A to Z, Ziffern 0 to 9, und gängige Satzzeichen. Akzentuierte Buchstaben und nicht-lateinische Schriften sind nicht Teil dieser Tabelle und werden daher beim Kodieren übersprungen.`)
};

const nl_mc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het gebruikt de standaard International Morse set — de letters A tot Z, cijfers 0 tot 9 en veel voorkomende interpunctie. Geaccentueerde letters en niet-Latijnse schriften maken geen deel uit van die tabel, dus worden ze overgeslagen bij codering.`)
};

const fr_mc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il utilise l'ensemble standard International Morse — les lettres A to Z, les chiffres 0 to 9, et la ponctuation courante. Les lettres accentuées et les scripts non-latins ne font pas partie de cette table, donc ils sont ignorés lors du codage.`)
};

const it_mc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizza l'insieme standard di Morse Internazionale — le lettere A to Z, le cifre 0 to 9, e la punteggiatura comune. Le lettere accentate e gli script non latini non fanno parte di quella tabella, quindi vengono saltati durante la codifica.`)
};

const pt_br2_mc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele usa o conjunto padrão de International Morse — as letras A to Z, dígitos 0 to 9 e pontuação comum. Letras acentuadas e scripts não-latinos não fazem parte dessa tabela, então são ignorados ao codificar.`)
};

const pt_mc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa o conjunto de International Morse padrão — as letras A to Z, dígitos 0 to 9 e pontuação comum. Letras acentuadas e scripts não-latinos não fazem parte dessa tabela, portanto são ignorados ao codificar.`)
};

const ja_mc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準的な International Morse セットを使用しています — A to Z の文字、0 to 9 の数字、および一般的な句読点。アクセント付き文字と非ラテン文字はそのテーブルの一部ではないため、エンコード時にスキップされます。`)
};

const zh_mc_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本工具使用标准的 International Morse 字符集——A to Z 的字母、0 to 9 的数字以及常见标点符号。带重音符号的字母和非拉丁文字不在该字符表中，因此在编码时会被跳过。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_faq4_a", locale)
	if (locale === "en") return en_mc_faq4_a(inputs)
	if (locale === "es") return es_mc_faq4_a(inputs)
	if (locale === "de") return de_mc_faq4_a(inputs)
	if (locale === "nl") return nl_mc_faq4_a(inputs)
	if (locale === "fr") return fr_mc_faq4_a(inputs)
	if (locale === "it") return it_mc_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_mc_faq4_a(inputs)
	if (locale === "pt") return pt_mc_faq4_a(inputs)
	if (locale === "ja") return ja_mc_faq4_a(inputs)
	return zh_mc_faq4_a(inputs)
};